import { Col, H1, H4, H5, P, Row, Span, Wrapper } from '@ahmdigital/ui';
import { PropsWithChildren, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './styles.module.sass';

const VARIANTS = {
  DARK: 'dark',
  LIGHT: 'light',
} as const;

type VariantType = (typeof VARIANTS)[keyof typeof VARIANTS];
type Alignment = 'left' | 'center';

type BannerProps = PropsWithChildren<{
  alignment?: Alignment;
  callout?: ReactNode;
  className?: string;
  description?: ReactNode;
  note?: string;
  preHeading?: string;
  title?: ReactNode;
  variant?: VariantType;
}>;

const Banner = ({
  alignment = 'left',
  callout,
  children,
  className,
  description,
  note,
  preHeading,
  title,
  variant = 'dark',
}: BannerProps) => {
  const descriptionElement = description && <H4 variant="regular">{description}</H4>;
  const noteElement = note && <H5 variant="marginTopSpacer9">{note}</H5>;
  const titleElement = title && <H1>{title}</H1>;
  const preHeadingElement = preHeading && (
    <P looksLike="h4" variant="marginBottomSpacer9">
      {preHeading}
    </P>
  );

  return (
    <div className={classNames(styles.root, styles[alignment], styles[variant], className)}>
      <Wrapper>
        {callout ? (
          <Row>
            <Col df={8} sm={12}>
              {preHeading && preHeadingElement}
              {title && titleElement}
              {description && descriptionElement}
              {note && noteElement}
              {children}
            </Col>
            <Col className={styles.calloutContainer} df={4}>
              {callout}
            </Col>
          </Row>
        ) : (
          <>
            {preHeading ? (
              <H1 variant="marginBottomSpacerNone">
                <Span className={styles.preHeading} looksLike="h4" variant="marginBottomSpacer9">
                  {preHeading}
                </Span>

                <Span looksLike="h1" variant="marginBottomSpacerNone">
                  {title}
                </Span>
              </H1>
            ) : (
              <H1 variant="marginBottomSpacerNone">{title}</H1>
            )}

            {(description || note) && (
              <Row>
                <Col df={10} md={12}>
                  {description && descriptionElement}
                  {note && noteElement}
                </Col>
              </Row>
            )}
            {children}
          </>
        )}
      </Wrapper>
    </div>
  );
};

export default Banner;
